import { triggerEvent } from '../../../fc-core/src/event-api';
import { sourceName, onDataLoadRequest, onDataLoadRequestCancel } from '../utils/url-transcoder-utils';
var BASE_FORMAT = 'json';
var UNDEF;

function fetchJSON(a, b, c, d, e) {
  triggerEvent('dataLoadRequested', e, {
    source: sourceName,
    url: a,
    dataFormat: BASE_FORMAT,
    silent: !!d,
    config: b,
    successcallback: c
  }, UNDEF, onDataLoadRequest, onDataLoadRequestCancel);
}

function setJSONUrl(a) {
  this.setChartDataUrl(a, 'jsonurl');
}

function wrapper(a) {
  return a && (a.prototype.setJSONUrl = setJSONUrl), {
    format: 'jsonurl',
    toJSON: fetchJSON
  };
}

export default {
  extension: wrapper,
  name: 'JSONUrl',
  type: 'transcoder',
  requiresFusionCharts: !0
};